import { render, staticRenderFns } from "./ImgCardProduct.vue?vue&type=template&id=e4604d64&"
import script from "./ImgCardProduct.vue?vue&type=script&lang=js&"
export * from "./ImgCardProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports